import { Divider, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { AttachmentsView } from 'components/@shared/Attachments';
import { PostResponseViewModel } from 'types/post';
import getTransformedDate from 'utils/getTransformedDate';

type Props = PostResponseViewModel;

const boxStyles = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'primary.main',
    borderRadius: '3px',
    p: 2,
};

export const AppointmentComment = ({ createdDate, author, message, attachments }: Props) => (
    <Box sx={boxStyles}>
        <Typography variant="body2" fontWeight={500}>
            {author.firstName} {author.lastName}
            <Typography variant="caption" component={'span'}>
                {' '}
                ({author.email})
            </Typography>
        </Typography>
        <Box display="flex" gap={2}>
            <Typography variant="body2" fontStyle="italic">
                {getTransformedDate(createdDate, 'MMM DD YYYY [at] HH:MM A')}
            </Typography>
        </Box>
        <Divider />
        <Box pl={4} pt={1}>
            <Typography mb={1}>{message}</Typography>
            <AttachmentsView list={attachments} />
        </Box>
    </Box>
);
